// Мост между вкладками демо-режима.
// Владелец и клиент — разные вкладки одного браузера. localStorage хранит
// записи, но вкладка владельца про новую запись не узнаёт: storage-событие
// приходит только в «другие» вкладки, а React Query ничего не перезапрашивает.
// Здесь: пометка «данные изменились» + ключ, чтобы вкладка владельца
// перезагрузила список сама.

export const DEMO_BOOKINGS_KEY = 'mnc-demo-bookings';
const SIGNAL_KEY = 'mnc-demo-bookings-signal';
const CHANNEL = 'mnc-demo-bookings';

// Сообщить всем вкладкам, что список записей изменился.
export function pingDemoBookings(): void {
  try {
    // 1. storage-событие для других вкладок
    localStorage.setItem(SIGNAL_KEY, String(Date.now()));
  } catch {
    /* приватный режим — остаётся BroadcastChannel */
  }
  try {
    const bc = new BroadcastChannel(CHANNEL);
    bc.postMessage({ at: Date.now() });
    bc.close();
  } catch {
    /* BroadcastChannel не везде — не критично */
  }
}

// Подписка на изменения. Возвращает функцию отписки.
export function subscribeDemoBookings(onChange: () => void): () => void {
  const onStorage = (e: StorageEvent) => {
    if (e.key === DEMO_BOOKINGS_KEY || e.key === SIGNAL_KEY) onChange();
  };
  window.addEventListener('storage', onStorage);

  let bc: BroadcastChannel | null = null;
  try {
    bc = new BroadcastChannel(CHANNEL);
    bc.onmessage = () => onChange();
  } catch {
    bc = null;
  }

  return () => {
    window.removeEventListener('storage', onStorage);
    try {
      bc?.close();
    } catch {
      /* noop */
    }
  };
}
